module.exports = __webpack_public_path__ + "static/media/sun-haze.0bb2c5fb.svg";